import { gql } from '@apollo/client';

export const SEARCH_THIRD_PARTY_COMPANIES = gql`
    query ThirdPartyCompanies(
        $search: String!
        $division: Int!
        $groupId: ID!
        $companyWeightingType: Int
    ) {
        thirdPartyCompanies(
            searchTerm: $search
            division: $division
            groupId: $groupId
            weightingType: $companyWeightingType
        ) {
            id
            type
            name
            displayName
            parentName
            countryCode
            isNonClient
        }
    }
`;

export const SEARCH_THIRD_PARTY_COMPANY_PARENTS = gql`
    query ThirdPartyCompanyParents($search: String!, $division: Int!) {
        thirdPartyCompanyParents(searchTerm: $search, division: $division) {
            id
            type
            name
            displayName
            parentName
            countryCode
        }
    }
`;

export const GET_GAIN_ACCOUNTS_BY_IDS = gql`
    query GainAccountsByIds($ids: [String]!, $division: Int!) {
        gainAccountsByIds(ids: $ids, division: $division) {
            id
            parentId
            name
            displayName
            parentName
            countryCode
            type
        }
    }
`;

export const GET_GAIN_ACCOUNT_GROUPS_BY_IDS = gql`
    query GainAccountGroupsByIds($ids: [String]!, $division: Int!) {
        gainAccountGroupsByIds(ids: $ids, division: $division) {
            id
            parentId
            name
            displayName
            parentName
            countryCode
            type
        }
    }
`;

export const GET_CUSTOM_ACCOUNTS_BY_IDS = gql`
    query CustomAccountsByIds($ids: [String]!, $division: Int!) {
        customAccountsByIds(ids: $ids, division: $division) {
            id
            parentId
            name
            displayName
            parentName
            countryCode
            type
        }
    }
`;

export const CREATE_CUSTOM_COMPANY = gql`
    mutation createCustomCompany(
        $createCustomCompanyModel: CreateCustomCompanyInput!
    ) {
        createCustomCompany(
            createCustomCompanyModel: $createCustomCompanyModel
        ) {
            company {
                value
                name
                partType
            }
            error
        }
    }
`;
